module.exports = __webpack_public_path__ + "assets/img/checked.919572c4.svg";